import type { Recipe } from '../data/types';

export function ReheatPanel({ recipe }: { recipe: Recipe }) {
  const ordered = [...recipe.reheat].sort((a, b) => (b.best ? 1 : 0) - (a.best ? 1 : 0));
  return (
    <div className="rounded-xl border border-freeze/25 bg-freeze-tint/60 p-5">
      <h3 className="font-sans text-[0.78rem] font-bold uppercase tracking-[0.1em] text-freeze">
        Freezing
      </h3>
      <p className="mt-2 font-serif leading-relaxed">{recipe.freezing}</p>
      <h3 className="mt-5 font-sans text-[0.78rem] font-bold uppercase tracking-[0.1em] text-freeze">
        Reheating — best first
      </h3>
      <ol className="mt-2 space-y-3">
        {ordered.map((r) => (
          <li key={r.method} className="font-serif leading-relaxed">
            <span className="font-semibold">
              {r.method}
              {r.best && (
                <span className="ml-2 rounded-full bg-freeze px-2 py-0.5 align-middle font-sans text-[0.66rem] font-bold uppercase tracking-[0.08em] text-paper">
                  Best way
                </span>
              )}
            </span>
            <span className="block text-[0.97rem]">{r.detail}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
